import {all, call, fork, put, takeEvery} from 'redux-saga/effects';
import {fetchRankIndicatorsSuccess, showMessage} from 'actions/RankIndicators';
import {RANK_INDICATORS_CHANGE,FETCH_RANK_INDICATORS} from 'constants/ActionTypes';
import { Storage } from 'codeArt/common';
import { INIT_STATE } from 'reducers/RankIndicators';


function _save(value){
  Storage.set("RankIndicators",value);
}


function* saveRequest({payload}) {
  try {
    _save(payload);
  } catch (error) {
    yield put(showMessage(error));
  }
}

function* save() {
  yield takeEvery(RANK_INDICATORS_CHANGE, saveRequest);
}




function _load(){
  return Storage.get("RankIndicators") || INIT_STATE.value;
}


function* loadRequest(v) {
  try {
    let value = _load();
    yield put(fetchRankIndicatorsSuccess(value));
  } catch (error) {
    yield put(showMessage(error));
  }
}

function* load() {
  yield takeEvery(FETCH_RANK_INDICATORS, loadRequest);
}


export default function* rootSaga() {
  yield all([fork(save), fork(load)]);
}